import React, { Component } from 'react';
import { TableDefault, Breadcrumb } from '../../../../components';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: '',
      page: 1,
      type: 1,
      pageSize: 100,
      totalItems: 0,
      orderBy: 'Descricao',
      order: '',
      urlDelete: '/Material',
      urlEdit: '/admin/material/produto/editar/',
      urlLoad: '/Material/GetListagem'
    };
  }

  create = () => {
    const { history } = this.props;
    const urlGo ='/admin/material/produto/editar';
    history.push(urlGo);
  };

  render() {
    const {
      page,
      pageSize,
      totalItems,
      search,
      order,
      orderBy,
      urlDelete,
      urlEdit,
      urlLoad,
      type
    } = this.state;

    return (
      <div>
        <Breadcrumb
          title='Materiais (Produtos Agência)'
          description='Gerencie os Materiais de Produtos Agência.'
          renderRight={(() => (
            <div className="flex v-sm-margin">
              <button
                className="bx--btn btn-secondary-color h-sm-margin"
                type="button"
                onClick={this.create}
              >
                Criar material
              </button>
            </div>
          ))()}
        />
        <section className="content-wrapper">
          <TableDefault
            search={search}
            type={type}
            order={order}
            orderBy={orderBy}
            page={page}
            pageSize={pageSize}
            totalItems={totalItems}
            urlDelete={urlDelete}
            urlEdit={urlEdit}
            urlLoad={urlLoad}
            onRef={ref => (this.tableList = ref)}
          />
        </section>
      </div>
    );
  }
}
export default List;



// WEBPACK FOOTER //
// ./src/screens/admin/Products/MaterialsManagement/List.js